module.exports = __webpack_public_path__ + "static/media/Z11.7078100b.jpg";